import { ComponentRef, ViewContainerRef } from '@angular/core';
import { timeout } from 'rxjs/operators';
import { ProfilePassKeySettingsComponent } from './profile-pass-key-settings.component';

class ProfilePasskeySettingsFormSession implements com.ts.mobile.sdk.UIFormSession{
  clientContext: object;
  actionContext: object;
  formId: string;
  payload: object;
  username: string;
  displayName: string;
  registeredKeys: any;

  submitHandler: any;
  submitBlock: (payload: object) => void;
  viewContainerRef: ViewContainerRef;
  profilePasskeySettingsComponent: ComponentRef<ProfilePassKeySettingsComponent>;

  constructor(formId: string, payload: object) {

  }
    startSession(clientContext: object | null, actionContext: com.ts.mobile.sdk.PolicyAction | null): void {

    this.clientContext = clientContext;
    this.actionContext = actionContext;
    this.viewContainerRef = (clientContext as any).viewContainerRef;
    this.registeredKeys = clientContext['passkeyDetails'];
  }
  endSession(): void {

  }
  promiseFormInput(): Promise<com.ts.mobile.sdk.FormInput> {
    // this.passkeyRegister();

    this.viewContainerRef.clear();

    this.profilePasskeySettingsComponent = this.viewContainerRef.createComponent(ProfilePassKeySettingsComponent);

    this.profilePasskeySettingsComponent.instance.registeredPasskeys = this.registeredKeys;

    this.profilePasskeySettingsComponent.instance.onPasskeyRemoveSubmit = this.onSubmitRemovePasskey.bind(this);
    this.profilePasskeySettingsComponent.instance.onPasskeyRemoveCancel = this.onPasskeySettingsCancel.bind(this);

    return new Promise((resolve, reject) => {
      this.submitBlock = (payload: object) => {
        try {
          resolve(com.ts.mobile.sdk.FormInput.createFormInputSubmissionRequest(Object.assign(payload)));
          this.submitBlock = null;
        } catch (e) {

        }
      };
    });
  }
  onContinue(payload: object): void {

  }
  onError(payload: object): void {
    const errorPayload = payload as JourneyPayload;
  }

  private onSubmitRemovePasskey(payload) {
    this.submitBlock(payload);
  }

  private onPasskeySettingsCancel(){

    const url = this.clientContext['redirect_uri'];
    const state = this.clientContext['state'];
    const errorCode  = 'cancel_passkey';
    let appendChar = '?';
    if (url.includes('?'))
    {
       appendChar = '&';
    }
    const redirectUrl = url + appendChar + 'error=' + errorCode + '&error_description=cancel_passkey'
    + '&lang=' + this.clientContext['cookieService'].get('lang')
    + '&state=' + state;
    const logout = this.clientContext['logout'];
    if (logout) {
      logout().finally(() => { window.location.href = redirectUrl; });
    } else {
      window.location.href = redirectUrl;
    }
  }
}

interface JourneyPayload {
  actions: ActionsInPayload[];
  stat: string;
  code: string;
  flow: string;
  recaptchastatus: string;
  loginhint: string;
}

interface ActionsInPayload {
  [key: string]: any;
}

export default ProfilePasskeySettingsFormSession;
